<template>
    <div class="modal-overlay">
        <div class="modal-content max-width-800">
            <div class="panel-title">
                <h4>
                    <i :class="getFeatureIcons('dca')"></i>
                    <span> {{ getFeatureNames('dca') }} - {{ this.symbol }}</span>
                </h4>
                <span @click="closePanel"><i class="cursor-pointer ti-close right-side-toggle medium-icon"></i></span>
            </div>
            <div class="card card-body">
                <loading-container :loading="form.dcaCodeLoading">
                    <span class="cursor-pointer p-right" @click="showExplantions = true">
                        {{ $t('stocks.dca.read_more_tips') }}
                        <i class="ml-1 fa fa fa-lightbulb text-warning"></i>
                    </span>
                    <apexchart height="600px" :options="dcaChart.chartOptions" :series="dcaChart.series">
                    </apexchart>
                </loading-container>
            </div>
        </div>
        <modal :show="showExplantions === true" :close="() => {showExplantions = false}"
            :title="$t('stocks.dca.tipsCode', {code: this.symbol})" class="dca-tips">
            <div>
                <table class="table table-bordered tips-table">
                    <thead>
                        <tr vertical-align="baseline">
                            <th style="vertical-align: top">{{ $t(`stocks.dca.dcaIndex`) }}</th>
                            <th style="vertical-align: top">
                                <div><i class="fa fa-solid fa-circle text-warning"></i> {{ $t(`stocks.dca.good_level`)
                                    }}</div>
                                <div><i class="fa fa-solid fa-circle text-success"></i> {{ $t(`stocks.dca.great_level`)
                                    }}</div>
                                <div><i class="fa fa-solid fa-circle text-purple"></i> {{ $t(`stocks.dca.own`) }}</div>
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(item, index) in dcaChart.tips" :key="index">
                            <td>{{ $t(`stocks.${dcaChart.fields[index]}.title`) }}</td>
                            <td>
                                <div v-html="displayTips($t(`stocks.${dcaChart.fields[index]}.tip`,
                                    dcaChart.fields[index] === 'gross_profit_margin'
                                        ? { beforeVal: 100 - item.good_level, value: item.good_level }
                                        : { value: item.good_level }), 'text-warning')">
                                </div>
                                <div v-html="displayTips($t(`stocks.${dcaChart.fields[index]}.tip`,
                                    dcaChart.fields[index] === 'gross_profit_margin'
                                        ? { beforeVal: 100 - item.great_level, value: item.great_level }
                                        : { value: item.great_level }), 'text-success')">
                                </div>
                                <div v-html="displayTips($t(`stocks.${dcaChart.fields[index]}.tip`,
                                    dcaChart.fields[index] === 'gross_profit_margin'
                                        ? { beforeVal: 100 - item.own, value: item.own }
                                        : { value: item.own }), 'text-purple')">
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div slot="footer">
                <div class="flex-group">
                    <button type="button" class="btn btn-secondary flex-item"
                        @click="() => {showExplantions = false}">
                        {{ $t('common.close') }}
                    </button>
                </div>
            </div>
        </modal>
    </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import LoadingContainer from "@/components/Misc/LoadingContainer";
import Modal from "@/components/Misc/Modal";
import common from "@/libs/common";

export default {
    components: {
        LoadingContainer,
        Modal
    },
    props: {
        symbol: {
            type: String,
            default: ''
        }
    },
    beforeMount() {
        this.getDCAChart(this.symbol);
    },
    data() {
        return {
            showExplantions : false,
        };
    },
    computed: {
        ...mapGetters({
            form: "evaluation/form",
            setField: "stock/setField",
            defaultCode: "configuration/defaultCode",
            dcaChart: "evaluation/dcaChart",
        }),
    },
    methods: {
        ...mapActions({
            getDCAChart: "evaluation/getDCACode",
            setDefaultCode: "configuration/setDefaultCode",
        }),
        getFeatureNames(name) {
            return common.getFeatureNames(name);
        },
        getFeatureIcons(name) {
            return common.getFeatureIcons(name);
        },
        displayTips(data, type) {
            const text = `<span class="${type}">`;
            const split = data.split('|');
            const list = [];
            for (let i = 0; i < split.length; i++) {
                if (i % 2 === 1) {
                    list.push(`${text}${split[i]}</span>`);
                } else {
                    list.push(`${split[i]}`);
                }
            } return list.join(' ');
        },
        closePanel() {
            this.$emit('close');
        }
    }
}
</script>